export default __webpack_public_path__ + "static/media/thumbnail3.401fd4f0.jpg";